const MwlImage = (data) => {
  const id = data.id
  const title = data.title
  const index = data.index
  const caption = data.caption
  const low_res_src = data.img_low_res_src
  const src = data.img_src
  const gps = data.img_gps
  const srcset = data.img_srcset
  const sizes = data.img_sizes
  const dimensions = data.dimensions
  const orientation = data.img_orientation
  const exifs = data.img_exifs
  const download_link = data.download_link

  return {
    id,
    title,
    index,
    caption,
    low_res_src,
    src,
    gps,
    srcset,
    sizes,
    dimensions,
    orientation,
    exifs,
    download_link
  }
}

export default MwlImage
